export default "__VITE_ASSET__0fd7a499__"